/* Keep decorative text arrows consistent across desktop and emoji-capable devices. */
(() => {
  const paths = {'↗':'M5 19 19 5M5 5h14v14','↘':'M5 5 19 19M5 19h14V5','↖':'M19 19 5 5M19 5H5v14','↙':'M19 5 5 19M19 19H5V5','→':'M4 12h16m-7-7 7 7-7 7','←':'M20 12H4m7-7-7 7 7 7','↑':'M12 20V4m-7 7 7-7 7 7','↓':'M12 4v16m-7-7 7 7 7-7','➡':'M4 12h16m-7-7 7 7-7 7','⬅':'M20 12H4m7-7-7 7 7 7','⬆':'M12 20V4m-7 7 7-7 7 7','⬇':'M12 4v16m-7-7 7 7 7-7'};
  const pattern = /[↗↘↖↙→←↑↓➡⬅⬆⬇][\uFE0E\uFE0F]?/g;
  function convert(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (!node.parentElement || node.parentElement.closest('script,style,textarea,input,select,option,svg,code,pre,[contenteditable="true"]')) continue;
      pattern.lastIndex = 0;
      if (pattern.test(node.data)) nodes.push(node);
    }
    for (const node of nodes) {
      const fragment = document.createDocumentFragment(); let cursor = 0;
      pattern.lastIndex = 0;
      for (const match of node.data.matchAll(pattern)) {
        fragment.append(node.data.slice(cursor, match.index));
        const svg = document.createElementNS('http://www.w3.org/2000/svg','svg');
        for (const [key,value] of Object.entries({viewBox:'0 0 24 24',width:'1em',height:'1em',fill:'none',stroke:'currentColor','stroke-width':'1.6','stroke-linecap':'round','stroke-linejoin':'round','aria-hidden':'true',focusable:'false'})) svg.setAttribute(key,value);
        svg.style.cssText='display:inline-block;width:1em;height:1em;vertical-align:-.12em;flex-shrink:0;pointer-events:none';
        const path = document.createElementNS('http://www.w3.org/2000/svg','path');path.setAttribute('d',paths[match[0][0]]);svg.append(path);fragment.append(svg);cursor=match.index+match[0].length;
      }
      fragment.append(node.data.slice(cursor));node.replaceWith(fragment);
    }
  }
  const observer = new MutationObserver(() => {observer.disconnect();convert(document.body);observe();});
  function observe(){observer.observe(document.body,{childList:true,subtree:true,characterData:true});}
  convert(document.body);observe();
})();
